import React, { useState } from 'react';
import Modal from '../../components/Modal';
import PanelCustomization from '../../panel/PanelCustomization';

const BundleCustomizationOverlay = ({ activeProduct, onModalHidden, onCustomizationSave }) => {
	const [currentSelections, setCurrentSelections] = useState(null);

	const omsOrderableItemId = activeProduct?.omsOrderableItemId;
	const omsRequisition = activeProduct?.omsRequisition;
	const loading = !!omsRequisition?.loading;
	const error = !!omsRequisition?.error;

	if (!activeProduct?.omsOrderableItemId) {
		return null;
	}
	return (
		<Modal
			id={`${omsOrderableItemId}-customization-modal`}
			displayProps={{ modalContent: { className: 'modal-content modal-scroll' } }}
			title={`Customize ${activeProduct?.name || ''}`}
			confirmAction={omsRequisition?.orderableItem && 'Save'}
			cancelAction={'Cancel'}
			onSave={() => {
				onCustomizationSave(currentSelections);
			}}
			modalHidden={onModalHidden}
			modalXL={omsRequisition?.orderableItem?.collectionPackSupplier === "CSS"}
		>
			{!omsRequisition?.orderableItem && loading && (
				<div className="text-center" style={{ padding: '15px' }}>
					<i className="fa fa-spinner fa-spin fa-fw" style={{ fontSize: '5em' }}></i>
				</div>
			)}
			{!omsRequisition?.orderableItem && error && (
				<div className="text-center">
					<span className="text-danger">An unexpected error has occurred.</span>
				</div>
			)}
			{omsRequisition?.orderableItem && (
				<PanelCustomization
					gearRequisition={{
						omsOrderableItemId: activeProduct.omsOrderableItemId,
						omsOrderableItemName: activeProduct.name,
						components: activeProduct.components || [],
						addons: activeProduct.addons || [],
						panel: activeProduct.panel,
						patientInstructions: activeProduct.patientInstructions
					}}
					omsRequisition={omsRequisition}
					onSelection={setCurrentSelections}
					displayPatientInstructions={false}
					orderType={'dropShip'}
				>
					<h4>
						Select a profile, components, or add-ons to pre-fill the test selection portion of the
						requisition.
					</h4>
				</PanelCustomization>
			)}
		</Modal>
	);
};

export default BundleCustomizationOverlay;
